import request from 'react_api/requests';

export default class SitesAPI {
  static getSites({
    trial_id,
    language = '',
    lat = '',
    lng = '',
    radius = '',
    country = '',
    place = '',
  }) {
    const URL = `/api/fetchsites/?trial_id=${trial_id}&user_lat=${lat}&user_lng=${lng}&language=${language}&within=${radius}${
      country ? '&country' + '=' + country : ''
    }&place=${place}`;
    return request.getCall(URL);
  }
}
